<template>
  <div>

    <b-modal
      id="modal-doctor"
      size="xl"
      modal-class="medhop-lookup-modal medhop-doctor-modal"
      body-class="medhop-lookup-modal__body"
      hide-header
      hide-footer
    >
      <header class="medhop-lookup-modal__header">
        <span class="medhop-lookup-modal__icon"><i class="fas fa-user-md"></i></span>
        <div>
          <h2>Pilih dokter</h2>
          <p>Cari dokter berdasarkan nama atau poliklinik.</p>
        </div>
        <button type="button" class="medhop-lookup-modal__close" aria-label="Tutup" @click="$bvModal.hide('modal-doctor')">
          <i class="fas fa-times"></i>
        </button>
      </header>
      <b-tabs pills class="medhop-lookup-modal__tabs" content-class="mt-3">
        <b-tab
          title="Daftar Dokter"
          active
        >
          <Table
            purpose="modal"
            :items="items"
            :fields="fields"            
            @chooseDoctor="chosenDoctor"
          />
        </b-tab>
        <b-tab title="Tambah Baru">
          <b-form class="medhop-lookup-modal__new-form" @submit.stop.prevent="customDoctorFormOnSubmit">
            <b-form-group
              id="input-group-name"
              label="Nama Dokter:"
              label-for="input-name"
            >
              <b-form-input
                id="input-name"
                v-model="form.name"
                placeholder="Nama Dokter"
                required
              ></b-form-input>
            </b-form-group>
            <!-- Button -->
            <b-button
              type="submit"
              variant="primary"
            >Simpan</b-button>
            <b-button
              class="ml-2"
              variant="default"
              @click="$bvModal.hide('modal-doctor')"
            >
              Batal
            </b-button>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-modal>

  </div>
</template>

<script>

import Table from '@/component/doctors/Table.vue'

export default {

  components: {
    Table
  },

  data() {
    return {
      // pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "number",
          label: '#',
          sortable: true,
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "mobile_phone",
          label: "Nomor Telepon",
          sortable: true,
        },
        {
          key: "polyclinic_name",
          label: "PoliKlinik",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      // Form
      form: {
        name: ''
      }
    }
  },

  methods: {

    chosenDoctor(value) {
      this.$emit('chosenDoctor', value)
    },

    customDoctorFormOnSubmit() {
      this.$emit('customSubmitedDoctor', this.form.name)
    }

  }

}
</script>
